import styled from 'styled-components';

const DateOfBirthStyled = styled.div`
  .form-label {
    font-size: 14px !important;
    font-weight: 600 !important;
    margin-bottom: 8px !important;
    color: ${(props) => props.theme.text.medium} !important;
  }

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'auto')};

  .yoberror {
    font-size: 15px;
    letter-spacing: -0.25px;
  }
  .dob-wrapper {
    display: flex;
    align-items: end;
    justify-content: space-between;

    > div {
      padding: 0;

      &:first-child {
        button {
          border-radius: 8px 0 0 8px !important;
        }
      }

      &:last-child {
        button {
          border-radius: 0 8px 8px 0 !important;
          width: 92% !important;

          &::after {
            right: 26px !important;
          }
        }
      }

      &:nth-child(2) {
        button {
          border-radius: 0 !important;
          border-left: 0 !important;
          border-right: 0 !important;
        }
      }
    }

    button {
      padding: 12px 12px !important;
      height: 50px !important;
      box-sizing: border-box !important;
    }

    button:disabled {
      opacity: 0.5 !important;
      background-color: ${(props) => props.theme.color.white} !important;
      border: 2px solid ${(props) => props.theme.color.borderLight} !important;
    }

    > div:first-child {
      padding-left: 8px;
    }

    .dropdown-menu {
      max-height: 160px;
      overflow: auto;
    }
    .dobdropdown {
      button {
        width: 100%;
      }
    }
    .error-border {
      button {
        border-color: ${(props) => props.theme.verification.red.main};
        width: 100%;
      }
    }
  }
`;

export default DateOfBirthStyled;
